import { AloftPriceJSON } from '@aloft/shared-objects';
import { AloftPrice, isUndefined, orUndefined } from '@aloft/toolkit-shared';

export function priceJSONToPrice(priceJSON: AloftPriceJSON | undefined): AloftPrice | undefined {
  const price = orUndefined(AloftPrice.schema.safeParse)(priceJSON);
  if (isUndefined(price) || !price.success) {
    return undefined;
  }
  return price.data;
}
